<template>
  <v-container grid-list-sm text-xs-left>

    <v-layout row
              wrap
              pa-2
              align-end>
      <v-flex xs12 py-2>
        <span class="display-2">Startup Registration</span>
      </v-flex>
      <v-flex xs12 pb-4>
        <span class="headline">Here you can register your startup to <strong>NTT DATA Discovery</strong>.</span>
        <br>
        <span class="headline">If you haven't received your identification token by email yet, you can register here to receive it and use it to subscribe to the challenges.</span>
        <br>
        <span class="headline">If you have lost or forgotten your token <a
            href="mailto:nttdata.discovery@nttdata.com?subject=Token%20request">contact</a> the NTT DATA Discovery administrators.</span>
      </v-flex>
    </v-layout>

    <FormStartupRegistration :startupId="startupId" ref="form"></FormStartupRegistration>

    <vue-recaptcha class="display-button" ref="recaptcha" sitekey="6LfZA3cqAAAAAM24XBOAwmmDmoLgPdpxDM_hZf6l"
                   @verify="register" @expired="onCaptchaExpired">
      <div id="html-element"></div>
      <br>
      <v-btn round :dark="privacyAccepted && validCaptcha" color="green" :disabled="!privacyAccepted || !validCaptcha"
             @click="submit">
        Submit
      </v-btn>
    </vue-recaptcha>


    <v-btn round dark color="red" @click="clear">
      Clear
    </v-btn>
    <v-flex pt-3 v-if="!privacyAccepted">
      <span style="color:red">* You have to accept Information Policy. Click <a style="text-decoration: underline;"
                                                                                @click="privacy = true">here</a></span>
    </v-flex>

    <v-dialog
        v-model="privacy"
        max-width="500"
        persistent>
      <v-card>
        <v-card-title class="headline">Information Policy</v-card-title>
        <v-card-text>
          <v-flex>
            <p class="subheading">Read <a download @click="privacyDowloaded=true"
                                          href="docs/Information Notice of NTT DATA Italia S.p.A to Clients.pdf">here</a>
              NTT DATA Information Policy</p>
          </v-flex>
          <v-flex>
            <v-checkbox
                v-model="checkbox"
                label="I declare to have read and understood the privacy policy according to the European regulation n. 2016/679 (c.d. GDPR) on the processing of personal data"
            ></v-checkbox>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              round
              color="red"
              flat
              @click="privacy=false"
          >
            Close
          </v-btn>
          <v-btn
              :disabled="!checkbox || !privacyDowloaded"
              round
              color="green"
              flat
              @click="accept()"
          >
            Accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-container>
</template>


<script>

import FormStartupRegistration from "@/pages/Admin/Innovation/FormStartupRegistration";
import VueRecaptcha from 'vue-recaptcha';


export default {
  name: "StartupRegistration",
  components: {FormStartupRegistration, VueRecaptcha},
  data: () => ({
    startupId: "",
    privacy: true,
    checkbox: false,
    privacyDowloaded: false,
    privacyAccepted: false,
    token: "",
    validCaptcha: false
  }),
  mounted() {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    document.head.appendChild(recaptchaScript)
  },

  methods: {
    register(token) {
      this.token = token;
      this.validCaptcha = true;
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.validCaptcha = false;
    },
    submit() {
      this.$refs.form.submit(this.token);
      this.validCaptcha = false;
      this.$refs.recaptcha.reset()
    },
    clear() {
      this.$refs.form.clear();
    },
    accept() {
      this.privacy = false;
      this.privacyAccepted = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.display-button {
  display: inline;
}
</style>

